module.exports = __webpack_public_path__ + "img/qilin-f-stage7.f611c7e7.png";